import angular from 'angular'
import 'ng-file-upload'
import inputContainerModule from '../forms/inputContainer/inputContainer'

import attachmentUploadComponent from './attachmentUpload.component'

export default angular.module('app.common.attachmentUpload', ['ngFileUpload', inputContainerModule.name])
  .directive('attachmentUpload', attachmentUploadComponent)
